module.exports = __webpack_public_path__ + "img/SV.3967202c.png";